import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RuntimeContext } from '../../../common/RuntimeContext';
import { getCollection } from '../../shared/actions/Collections';
import { getManyUserCollections, getUserCollection } from '../../shared/actions/UserCollections';
import FullPageLoadingIndicator from '../../shared/components/FullPageLoadingIndicator';
import Collection from '../../shared/containers/Collection/Collection';
import MyCollection from '../../shared/containers/MyCollection/MyCollection';
import { isValidId } from '../../shared/utils/StringUtils';

class CollectionPage extends Component {
    static propTypes = {
        loggedInUser: PropTypes.object,
        match: PropTypes.object.isRequired,
        getManyUserCollections: PropTypes.func,
        getUserCollection: PropTypes.func,
        getCollection: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
            state: PropTypes.object
        }),
        history: PropTypes.object.isRequired
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            shouldDisplayUserCollectionComponent: false,
            userCollection: {},
            isLoading: true
        };
    }

    componentDidMount() {
        const { match, history, loggedInUser, getCollection, location: { state = {} } = {}} = this.props;
        const { pathsWeb } = this.context;
        if (match.params.section && match.params.section === 'journey') {
            const updatedPathName = match.url.replace('/journey', '/path');
            history.replace({
                pathname: updatedPathName,
                state
            });
        }
        if (match.params.id && loggedInUser._id) {
            return getCollection({ collectionId: match.params.id, pathsContext: this.context.pathsWeb })
            .then(() => this._getExistingUserCollection())
            .catch(() => window.location.replace(`${pathsWeb.clientUrl}/contentretirederrorpage`));
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        const { loggedInUser, match, getCollection } = this.props;
        const { pathsWeb } = this.context;
        if (!isEqual(prevProps.loggedInUser._id, loggedInUser._id) && match.params.id) {
            return getCollection({ collectionId: match.params.id, pathsContext: this.context.pathsWeb })
                .then(() => this._getExistingUserCollection())
                .catch(() => window.location.replace(`${pathsWeb.clientUrl}/contentretirederrorpage`));
        }
        return null;
    }

    _replaceLocationWithPermalink = (collectionPermalink) => {
        const { match, history, location: { pathname = '', state = {} } = {} } = this.props;
        if (isValidId(match.params.id)) {
            const splitPathname = pathname.split('/');
            splitPathname[2] = collectionPermalink || match.params.id;
            const updatedPathName = splitPathname.join('/');
            history.replace({
                pathname: updatedPathName,
                state
            });
        }
    };

    setCollectionState = (userCollection) =>
        this.setState({
            shouldDisplayUserCollectionComponent: true,
            userCollection,
            isLoading: false
        });

    _getExistingUserCollection = () => {
        const { match, loggedInUser, getManyUserCollections, getUserCollection } = this.props;
        const params = {
            collectionId: match.params.id,
            userProfileId: loggedInUser._id
        };

        return getManyUserCollections({ ...params, pathsContext: this.context.pathsWeb }).then((userCollections) => {
            const userCollection = userCollections && userCollections[0];
            if (userCollection && userCollection._id) {
                this._replaceLocationWithPermalink(userCollection.collectionPermalink);

                // This fetch only happens when activities' subscriptions have not been created for a userCollection
                // getUserCollection performs a check similar to the one here and updates the content array
                // We don't need to call this in any other scenario.
                if (
                    userCollection.content &&
                    userCollection.content[0] &&
                    !userCollection.content[0].userLearningAssetId
                ) {
                    return getUserCollection({
                        userCollectionId: userCollection._id,
                        pathsContext: this.context.pathsWeb
                    }).then((updatedUserCollection) => this.setCollectionState(updatedUserCollection));
                }
                return this.setCollectionState(userCollection);
            }
            return this.setState({ isLoading: false });
        });
    };

    render() {
        const { shouldDisplayUserCollectionComponent, userCollection, isLoading } = this.state;
        if (isLoading) {
            return <FullPageLoadingIndicator />;
        }
        if (shouldDisplayUserCollectionComponent) {
            return <MyCollection userCollection={userCollection} />;
        }
        return <Collection setCollectionState={this.setCollectionState} />;
    }
}

const makeMapStateToProps = () => (state) => {
    const {
        auth: { loggedInUser }
    } = state;
    return {
        loggedInUser
    };
};

const mapDispatchToProps = (dispatch) => ({
    getManyUserCollections: (params) => dispatch(getManyUserCollections(params)),
    getUserCollection: (params) => dispatch(getUserCollection(params)),
    getCollection: (params) => dispatch(getCollection(params))
});
export const CollectionPageComponent = CollectionPage;
export default withRouter(connect(makeMapStateToProps, mapDispatchToProps)(CollectionPage));
